export const PasswordValidationCallbacks = [
  (v: string) => {
    return v.match(/[^A-Za-z\d.,!@#$%^&*?(){}[\]|_<>]/) ? 'Forbidden characters found. Allowed characters are: A-Za-z0-9.,!@#$%^&*%?(){}[]|_<>' : true;
  },
  (v: string) => v.length <= 0 || v.length >= 10 || 'Password must be at least 10 characters long',
  (v: string) => {
    const errors = ['Password does not match the following criteria:'];
    if (!!v && !v.match(/^(?=.*[a-z])[A-Za-z\d.,!@#$%^&*?(){}[\]|_<>].+$/)) {
      errors.push('At least 1 lowercase character.');
    }

    if (!!v && !v.match(/^(?=.*[A-Z])[A-Za-z\d.,!@#$%^&*?(){}[\]|_<>].+$/)) {
      errors.push('At least 1 uppercase character.');
    }

    if (!!v && !v.match(/^(?=.*\d)[A-Za-z\d.,!@#$%^&*?(){}[\]|_<>].+$/)) {
      errors.push('At least 1 numeric character.');
    }

    if (!!v && !v.match(/^(?=.*[.,!@#$%^&*?(){}[\]|_<>])[A-Za-z\d.,!@#$%^&*?(){}[\]|_<>].+$/)) {
      errors.push('At least 1 special character.(.,!@#$%^&*?(){}[\\]|_<>)');
    }

    if (!!v && v.includes('\\')) {
      errors.push('Password should not include \\.');
    }

    if (errors.length > 1) {
      return errors.join(' ');
    }

    return true;
  },
  (v: string) => v.length <= 79 || 'Password must be maximum 79 characters long',
];

export const RealNameValidationCallbacks = [
  (v: string) => {
    return !v.match(/^[\w \t.,_-]*$/) ? 'Forbidden characters found. Allowed characters are: [A-Z a-z 0-9 . , _ - SPACE]' : true;
  },
  (v: string) => !v || v.length >= 3 || 'Real Name is required to be at least 3 characters!',
];

const emailRegex = /^[A-Za-z0-9.-]{3,}@[A-Za-z0-9.-]{3,}\.[A-Za-z.-]{2,3}$/;

export const singleEmailValidation = (errorMessage: string = "Value must be a valid email address") => [
  (v: string) => {
    return v && emailRegex.test(v) || errorMessage;
  },
];

export const multipleEmailValidation = (errorMessage: string = "All the values must be valid email addresses") => [
  (v: string[]) => {
    if (!v || !v.length) {
      return true;
    }
    return v.every((v) => v && emailRegex.test(v)) || errorMessage;
  },
];
